import { IProps, Textbox } from "../Textbox";

import styles from "./DescriptionInput.scss";

export class DescriptionInput extends Textbox {
    constructor(props: IProps) {
        super(props, styles.descriptionInput, false);
    }
}

export default DescriptionInput;


// WEBPACK FOOTER //
// ./src/Components/Common/Input/TextBoxes/DescriptionInput/DescriptionInput.tsx